<div mat-dialog-content>
    <div class="mainDiv">
           <p mat-dialog-title style="margin: 0 0 10px; width: 400px;font-size: 16px;">Why are you closing this post, please mention the reason below.</p>
           <form [formGroup]="closeform">
            <!-- <input  type="text" placeholder="Remark" [(ngModel)]="userName" style="width: 100%;"/>  -->
       <textarea type="text" placeholder="Remark" formControlName="Remark" required  minlength="5" maxlength="100" rows="3"style="width: 100%;"></textarea>
 
        <div style="float: right;margin-top: 10px;margin-bottom: 13px;">
            <button type="submit" mat-button  style="margin-right: 5px;" class="btn btncls" (click)="onSubmit()">Submit</button>
            <button mat-button class="btn btncls" (click)="onNoClick()">Cancel</button>
     </div>
      </form>
    </div>
</div>
<style>
  .btncls{
    width:100px;
    color: white;
    background-color: #234a90;
  }
  
  .mainDiv{
    padding: 10px 20px 10px 20px;
  }
  textarea {
    resize: none;
  }
  </style>
  
  
  <!-- <div mat-dialog-content>
    <div class="mainDiv">
      <p mat-dialog-title style="margin: 0 0 10px">Are you sure you want to delete this category? Please mention the reason below.</p>
      <form [formGroup]="profileForm">
        <textarea type="text" formControlName="Remark"  placeholder="Remark" maxlength="100" rows="3"
          style="width: 100%;"></textarea>
          
  
          
        <div style="float: right;margin-top: 10px;margin-bottom: 13px;">
          <button mat-button class="btn btncls"
            (click)="onSubmit()">Submit</button>&nbsp;
          <button mat-button class="btn btncls" (click)="onNoClicks()">Cancel</button>
        </div>
      </form>
    </div>
  </div> -->